import { Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'

export const DeviceSwitchedPage = observer(() => {
  const store = useContext(StoreContext)
  const { switchToMobile: trans } = store.TranslationsState.translationsNew

  return (
    <div className="page-container mobile-m-0">
      <Illustration type="device-switched" />

      <Header>{trans.close.header}</Header>

      <div className="generic__paragraph-centered">
        <p className="">{trans.close.description}</p>
      </div>
    </div>
  )
})
